import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';

lessRequire('modules/root/components/login-form.less');

const Form = ({
	handleSubmit,
	pristine,
	submitting,
	login,
	toggleRegister
}) => {
	return (
		<form className="login__form" onSubmit={handleSubmit(formData => login(formData))}>
			<h2>Login form</h2>
			<div className="login__form-element">
				<Field name="email" component="input" type="text" placeholder="Email"/>
			</div>

			<div className="login__form-element">
				<Field name="password" component="input" type="password" placeholder="Password"/>
			</div>

			<div className="login__form-element">
				<div className="login__form-element">
					<button type="submit" disabled={pristine || submitting}>Enter</button>
					<a onClick={toggleRegister} href="#">Register</a>
				</div>
			</div>
		</form>
	);
};

Form.propTypes = {
	handleSubmit: PropTypes.func,
	pristine: PropTypes.bool,
	submitting: PropTypes.bool,
	login: PropTypes.func,
	toggleRegister: PropTypes.func
};

export default reduxForm({
	form: 'loginForm'
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/login-form.js